import { Button, Select, Spin } from 'antd';
import Modal from 'antd/lib/modal/Modal';
import React, { useMemo, useState } from 'react';
import { useTranslations } from '../../hooks/translations';
import { Translate, translationService } from '../../services';
import { Flag } from '@nackle/intl-tools';
import './styles.less';
import WorldFlag from './world_flag.svg';
import { ACTIVE_THEME_NAME } from '../../branding';
import classNames from 'classnames';
import { PaperIcon } from '@nackle/paper';


function getLabel( locale ) {
    return locale.label ?? locale.labelEnUs ?? locale.code ?? '?';
}

function getFlagIcon( locale ) {
    const country = ( locale.code ?? locale ).split( '-' )[ 1 ];

    if ( country == 'IW' ) {
        return <Flag code='IL' />;
    }

    if ( country == 'XX' ) {
        return <img src={ WorldFlag } />;
    }
    
    return <Flag code={ country } />;
}

export const LanguageSelector = ( { visible, onCancel, onOk } ) => {

    const { setLocale, locale, userLocale, supportedLanguages, isLoading, error } = useTranslations();

    const [ selectedLocale, setSelectedLocale ] = useState( locale );
    const [ loading, setLoading ] = useState( true );

    const locales = useMemo( () => {

        if ( locale ) {setLoading( false );}

        return [
            ...supportedLanguages
                .filter( l => [ locale, userLocale ].includes( l.code ) )
                .sort( ( l1, l2 ) => getLabel( l1 ).localeCompare( getLabel( l2 ) ) ),
            ...supportedLanguages
                .filter( l => ![ locale, userLocale ].includes( l.code ) )
                .sort( ( l1, l2 ) => getLabel( l1 ).localeCompare( getLabel( l2 ) ) )
        ];
        
    }, [ supportedLanguages, locale ] );

    function handleSubmit( ) {
        setLocale( selectedLocale );
        translationService.invokeManualUpdate( selectedLocale );
        onOk();
    }

    function searchFilter( input, option ) {
        return option.value.toLowerCase().includes( input ) || option.children.filter( x => typeof x === 'string' ).some( x => x.toLowerCase().includes( input ) );
    }

    return (
        <Modal title={ <Translate.Text className='_title' value='language.selector.title' /> }  destroyOnClose={ true } 
                visible={ visible } onCancel={ onCancel } onOk={ onOk }
                className={ classNames( 'langauge-selector-modal', ACTIVE_THEME_NAME ) }
                footer={ [
                    <Button loading={ loading } disabled={ loading } key='ok' type='primary' onClick={ handleSubmit } className='primary' >
                        <Translate.Text value='page.courseDetails.sections.ratings.actions.submit' />
                    </Button>
                ] }>
            <Translate.Text value='language.selector.body' />
            { loading ? <Spin /> :
                <div className='language-selector'>
                    <Select defaultValue={ locale } onChange={ ( value ) => setSelectedLocale( value ) } loading={ isLoading } disabled={ !!error }
                        showSearch filterOption={ searchFilter }
                    >
                        {
                            locales.map( l => <Select.Option className='language-selector-option' key={ l.code } value={ l.code }>{ getFlagIcon( l ) }{ getLabel( l ) }</Select.Option> )
                        }
                    </Select>
                </div>
            }
        </Modal>
    );
};

export const LanguageSelectorLink = ( { onClick: _onClick } ) => {

    const [ isModalVisible, setIsModalVisible ] = useState( false );
    const { locale, supportedLanguages } = useTranslations();

    const showModal = () => {
        setIsModalVisible( true );
    };

    function onClick() {
        showModal();
        _onClick();
    }

    const closeModal = () => {
        setIsModalVisible( false );
    };  

    function getShortLabel( label ) {
        let labelSplit;
        if ( ( labelSplit = label.split( ' ' ) ).length > 1 ) {
            return labelSplit[ 0 ];
        }

        return label;
    }

    return supportedLanguages.length == 0 ? (
        <>
            <span className='language-selector-link'>
                <Spin />
            </span>
      </>
    ) : (
        <>
            <span className='language-selector-link'>
                <PaperIcon icon="Global" collection="antd-outlined"/>
                <span className='language'>{ getShortLabel( getLabel( supportedLanguages.find( l => l.code == locale ) ) ) }</span> 
                <PaperIcon icon='Edit' collection='antd-outlined' className='edit-icon' onClick={ onClick } />
            </span>
            <LanguageSelector
                visible={ isModalVisible } onCancel={ closeModal } onOk={ closeModal }
            />
      </>
    );
};